import { Injectable } from '@angular/core';
import { ApiClient } from '@core/services/api-client.http.service';
import {
  PaginatedResponseDto,
  UserDataDto,
  UserGroupDetailsDto,
  UserManagementUsersDto,
} from '@core/services/dto';
import {
  BranchManagementUrls,
  OfferUrls,
  UserGroupManagementUrls,
  UserManagementUrls,
} from '@core/constants';
import { Observable } from 'rxjs';
import { UserManagementModel } from '@shared/models';
import { UserOfferUpdateApiRequest } from '@shared/models/requests/user-offer-update.request.dto';
import { AllBranchManagementBranchesDto, BranchManagementBranchesDto } from '../dto/branch-management-branches.dto';
import { UserManagementChangeLogUserDto } from '../dto/userchangelog.dto';

@Injectable({
  providedIn: 'any',
})
export class UserManagementApiService {
  constructor(private api: ApiClient) {}

  getAllUserData(): Observable<UserDataDto[]> {
    return this.api.get<UserDataDto[]>(UserManagementUrls.allusers);
  }

  getData(request): Observable<PaginatedResponseDto<UserManagementUsersDto>> {
    return this.api.get<PaginatedResponseDto<UserManagementUsersDto>>(
      UserManagementUrls.users,
      request
    );
  }

  getUserChangeLogData(request): Observable<PaginatedResponseDto<UserManagementChangeLogUserDto>> {
    return this.api.get<PaginatedResponseDto<UserManagementChangeLogUserDto>>(
      UserManagementUrls.usersChangeLog,
      request
    );
  }


  getOfferData(
    request
  ): Observable<PaginatedResponseDto<UserManagementUsersDto>> {
    return this.api.get<PaginatedResponseDto<UserManagementUsersDto>>(
      OfferUrls.offerUsers,
      request
    );
  }

  saveUserPermission(id, permissions): Observable<UserManagementUsersDto> {
    return this.api.put<UserManagementUsersDto>(
      UserManagementUrls.permissions(id),
      permissions
    );
  }

  getUserId(id): Observable<UserManagementUsersDto> {
    return this.api.get<UserManagementUsersDto>(UserManagementUrls.user(id));
  }

  updateUserId(id,request: UserManagementModel): Observable<UserManagementUsersDto> {
    return this.api.put<UserManagementUsersDto>(UserManagementUrls.user(id),request);
  }

  updateUserEmail(payload: { userId: string; email: string }): Observable<UserManagementUsersDto> {
  return this.api.put<any>(UserManagementUrls.updateUserEmail(payload.userId, payload.email));
}

  getPermissions(id): Observable<PaginatedResponseDto<number>> {
    return this.api.get<PaginatedResponseDto<number>>(
      UserManagementUrls.permissions(id)
    );
  }

  getPermissionsReportFile(): Observable<any> {
    return this.api.getFile(UserManagementUrls.permissionsReport);
  }

  getUserGroups(id): Observable<PaginatedResponseDto<UserGroupDetailsDto>> {
    return this.api.get<PaginatedResponseDto<UserGroupDetailsDto>>(
      UserManagementUrls.groups(id)
    );
  }

  saveUserGroups(id, ids): Observable<PaginatedResponseDto<number>> {
    return this.api.put<PaginatedResponseDto<number>>(
      UserManagementUrls.groups(id),
      ids
    );
  }

  getGroups(request): Observable<PaginatedResponseDto<UserGroupDetailsDto>> {
    return this.api.get<PaginatedResponseDto<UserGroupDetailsDto>>(
      UserGroupManagementUrls.groups,
      request
    );
  }

  createFolder(request): any {
    return this.api.get<any>(UserGroupManagementUrls.groups, request);
  }

  getOfferUserData(
    request
  ): Observable<PaginatedResponseDto<UserManagementUsersDto>> {
    return this.api.get<PaginatedResponseDto<UserManagementUsersDto>>(
      UserManagementUrls.users,
      request
    );
  }

  // sendActivation(request): Observable<UserManagementUsersDto> {
  //   return this.api.put<UserManagementUsersDto>(OfferUrls.OfferUser, request);
  // }

  sendActivation(request): Observable<UserManagementUsersDto> {
    return this.api.get<UserManagementUsersDto>(UserManagementUrls.sendActivation(request));
  }
  resetPassword(request): Observable<UserManagementUsersDto> {
    return this.api.get<UserManagementUsersDto>(UserManagementUrls.resetPassword(request));
  }

  enableDisableOfferUser(request): Observable<any> {
    return this.api.put<any>(OfferUrls.OfferUserEnable, request);
  }

  getBranches(request: any): Observable<PaginatedResponseDto<AllBranchManagementBranchesDto>> {
    return this.api.get<PaginatedResponseDto<AllBranchManagementBranchesDto>>(
      BranchManagementUrls.allBranches,
      request
    );
  }
}
